export const expensesZh = {
  title: '报销管理',
  create: '新建报销单',
  loading: '加载中...',
  filters: {
    all: '全部',
    draft: '草稿',
    pending: '审批中',
    approved: '已批准',
  },
  emptyTitle: '暂无报销单',
  emptyDesc: '您还没有创建报销单',
  emptyAction: '创建第一个报销单',
  columns: {
    number: '报销单号',
    title: '标题',
    amount: '金额',
    status: '状态',
    createdAt: '创建时间',
    actions: '操作',
  },
  actions: {
    view: '查看',
    edit: '编辑',
    delete: '删除',
  },
  confirm: {
    deleteTitle: '确定要删除这个报销单吗？',
  },
  error: {
    deleteFailed: '删除失败',
  },
  status: {
    DRAFT: '草稿',
    PENDING: '审批中',
    APPROVED: '已批准',
    REJECTED: '已拒绝',
  },
};

export type ExpensesTranslations = typeof expensesZh;
